import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=6274da83"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=6274da83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports